import type { IQuestionsPageProps } from '$/pages/registration/questions';
import type { IQuestionsPageStateProps } from './useQuestionsPage';

import React from 'react';

import QuestionWrapper from './QuestionWrapper';
import stepConfig from './stepConfig';

import QuestionsPage from '$/components/blocks/QuestionsPage';

export interface IQuestionsPageViewProps
  extends IQuestionsPageProps,
    IQuestionsPageStateProps {}

const QuestionsPageView = (props: IQuestionsPageViewProps) => {
  const componentProps = {
    mostPopularSpecializations: props.mostPopularSpecializations,
    degrees: props.degrees,
  };
  return (
    <QuestionsPage>
      <QuestionWrapper>
        {React.createElement(
          stepConfig[props.currentStep].Component,
          componentProps
        )}
      </QuestionWrapper>
    </QuestionsPage>
  );
};

export default QuestionsPageView;
